import { environmentCommonVariable } from "./environment-common";

const envProd: Partial<typeof environmentCommonVariable> = {
  production: true,
  sentryEnv: "production",
  /*//ORIGNAL CONTENT OF "Environment.prod.ts"
    httpServerRoot: "",
    staticFolderDownload: "/download/",
    AESSecuretyPrivateKey: "51655468566D5971",
    defaultButtonSupervisionColor: "#EAEAEA",
    defaultButtonSupervisionBorder: "thin solid rgb(146 146 146)",
    imageCustomerStaffDefault: "assets/img/User.png",
    apiFolderDownloads: "/downloads/",
    remoteServerLogAddress: "http://127.0.0.1:13001",
    ionicStoreConfig: {
      name: "__bigms3SQL",
      driverOrder: ["sqlite", "indexeddb", "websql", "localstorage"],
    },
    sentryEnv: "production",
  */
  theme: 1,

};

export const environment = { ...environmentCommonVariable, ...envProd };
